$(document).ready(function(){

    //check if cookie exists and set mode
    $('#mode').click(function(){
        if ($('body').hasClass('bg-dark')) {
            $('body').removeClass('bg-dark');
            $('#mode').html('<span class="material-icons">dark_mode</span>');
        } else {
            $('body').addClass('bg-dark');
            $('#mode').html('<span class="material-icons">light_mode</span>');
        }

        //save mode on cookie for 1 year
        var date = new Date();
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toUTCString();
        document.cookie = "mode=" + ($('body').hasClass('bg-dark') ? 'bg-dark' : '') + expires + "; path=/";
    });

    
    //inicializar select2
    $('.select2').select2({
        theme: 'bootstrap-5',
        language: 'es',
        width: '100%',
        "language": {
            "noResults": function(){
                return "No se encontraron resultados";
            }
        },
    });
    

    //autofocus en select2
    $(document).on('select2:open', () => {
        document.querySelector('.select2-search__field').focus();
    });

    $('.modal').on('shown.bs.modal', function () {
    var $modal = $(this);

    $modal.find('.select2').each(function() {
        var $select = $(this);
    
        if ($select.hasClass('select2-hidden-accessible')) {
            $select.select2('destroy');
        }

        $select.select2({
            theme: 'bootstrap-5',
            language: 'es',
            width: '100%',
            dropdownParent: $modal,
            "language": {
                "noResults": function(){
                    return "No se encontraron resultados";
                }
            },
        });
    });
});

// Bootstrap 5: evitar que el modal robe el foco al Select2
$(document).on('focusin', function(e) {
    if ($(e.target).closest('.select2-container').length) {
        e.stopImmediatePropagation();
    }
});

});